module.exports = __webpack_public_path__ + "static/img/songyimin.2d7f93f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_h5/songyimin.jpg
// module id = p+qy
// module chunks = 0